
import { Component, ElementRef, OnInit, ViewChild , Inject,EventEmitter,Output} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { HttpClient, HttpEventType, HttpResponse } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ReviewDetail } from 'src/core/account/action/account.action';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ReviewPopupComponent } from '../review-popup/review-popup.component';
import { ProductComponent } from 'src/default/pages/products/product/product.component';
import { Location } from '@angular/common';




@Component({
  selector: 'app-review-details',
  templateUrl: './review-details.component.html',
  styleUrls: ['./review-details.component.css']
})
export class ReviewDetailsComponent implements OnInit {
  @Output() dataConfirmed = new EventEmitter<void>();
  Response: any;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,public dialogRef: MatDialogRef<ReviewDetailsComponent>,public router: Router,private matdig: MatDialog,private location: Location) { 
    console.log("product id", data)
      this.Response = data.message
  }

  ngOnInit(): void {
    
  }

  onOkClick(): void {
    // Emit an event when OK is clicked
    this.dataConfirmed.emit();
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  close(){
    var title = ""
    this.dialogRef.close();


    // this.onOkClick()
    // this.refreshComponent()

    //  const dialogRef = this.matdig.open(ProductComponent, {
    //   })
    // this.router.navigate(['products/productdetails/5668',]);
    // this.location.back();
    // window.history.forward();
    // window.history.forward();
    // window.history.forward();
    // window.location.reload()
    // this.refreshComponent()


  }

  refreshComponent(): void {
    // Use Angular Router to navigate to the same route
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([this.router.url]);
    });
  }


}
